import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { PropType } from 'vue';
import { Tool } from '@/lib';
import { BaseIcon } from '@/lib/components/Icon';
import { BaseTooltip } from '@/lib/components/Tooltip';
import { BaseButton } from '@/lib/components/Button';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnotationToolbar',
  props: {
  tools: {
    type: Array as PropType<Tool[]>,
    default: () => []
  },
  modelValue: {
    type: String,
    default: null
  }
},
  emits: ["update:modelValue"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (__props.tools?.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bg-gray-900 rounded py-1 px-2 flex flex-row space-x-2",
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tools, (tool) => {
          return (_openBlock(), _createBlock(_unref(BaseTooltip), {
            key: tool.name,
            position: "above"
          }, {
            target: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass([tool.cornerstoneName === __props.modelValue ? 'text-white bg-primary-500' : 'hover:bg-gray-800 text-gray-400', "flex justify-center hover:text-white items-center h-8 w-8 rounded"]),
                onClick: _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', tool.cornerstoneName)), ["stop"])
              }, [
                _createVNode(_unref(BaseIcon), {
                  name: tool.icon
                }, null, 8, ["name"])
              ], 10, _hoisted_1)
            ]),
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(tool.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (__props.modelValue)
          ? (_openBlock(), _createBlock(_unref(BaseButton), {
              key: 0,
              size: "small",
              color: "dark",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', null)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('platform.common.close')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}
}

})